<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
     <div style="display: flex;align-items: center;">
      <div class="activityHeader">
        {{decodeURIComponent( $route.query.activityName) }}
      </div>
      <div style="display: flex;align-items: center;min-width: 200px;" v-if="mode!=0">
        <div style="font-size: 14px;color: #000;margin-left: 20px;">
          类型：
        </div>
      
        <el-select v-model="modeType" placeholder="請選擇類型" v-if="mode==3" >
              <el-option  label="入場" :value='1'></el-option>
              <el-option  label="上台" :value='2'></el-option>
            </el-select>
          <div v-if="mode==1" style="font-size: 14px;color: #000;">
            入场
          </div>
          <div v-if="mode==2" style="font-size: 14px;color: #000;">
            上台
          </div>
   
      </div>
     </div>
      <el-tabs @tab-click="handleClick">
        <el-tab-pane label=" 未核銷">
          <ItemList :status="0" :activityId="activityId" :mode="modeType"  :key="modeType"  v-if="status == 0"  ref="child"/>
        </el-tab-pane>
        <el-tab-pane label="已核銷">
          <ItemList :status="1" :activityId="activityId" :mode="modeType"   :key="modeType"  v-if="status == 1" ref="child"/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import ItemList from "./itemList.vue";
import { set } from "shelljs";
export default {
  data() {
    return {
      navBlock: "活動",
      navtitle: "核銷活動/核銷詳情",
      status: 0,
      activityId: "",
      mode:1,
      modeType:1
    };
  },
  created() {
    this.activityId = this.$route.query.activityId;
    this.mode=this.$route.query.mode
    if(this.mode==0){
      this.modeType=0
    }
    if(this.mode==1||this.mode==3){
      this.modeType=1
    }
    if(this.mode==2){
      this.modeType=2
    }
  
    
  },
  destroyed() {},
  methods: {
    handleClick(tab, events) {
      if (tab.paneName == 1) {
        this.status = 1;
      } else {
        this.status = 0;
      }
    },

  
  },
  components: {
    NavBar,
    ItemList
  }
};
</script>
<style scoped lang="less">
@import "../order/allOrder/el_tabs.less";
.activityHeader {
  text-align: left;
  font-size: 18px;
 
}
</style>



// WEBPACK FOOTER //
// src/pages/checkActivity/checkList.vue